module.exports = __webpack_public_path__ + "static/media/Buy_5_Days_Holidays.4c5b6a1f.svg";